// The carts of an order as the loading screens list them: Abarrote (CART-)
// before Frio (BASKET-), each with its number. Sorts a copy: the order data
// stays as it came from the server.
export const cartLabels = (carts) => [...(carts || [])]
  .sort((a, b) => Number(b.code.includes('CART')) - Number(a.code.includes('CART')))
  .map((cart) => ({
    code: cart.code,
    kind: cart.code.includes('CART') ? 'Abarrote' : 'Frio',
    number: cart.code.split('-')[1],
  }));
